import { render } from "./ContactMania.vue?vue&type=template&id=7b56459a&scoped=true"
import script from "./ContactMania.vue?vue&type=script&lang=js"
export * from "./ContactMania.vue?vue&type=script&lang=js"

import "./ContactMania.vue?vue&type=style&index=0&id=7b56459a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b56459a"]])

export default __exports__